const stakeAddress = "0x59F7577435F5A02150699C56b7651Eb559f451A9" //Contract Address

export default stakeAddress;